import React, { Component } from 'react';

class StatusComponent extends Component {
    constructor(props) {
        super(props);
    }

    render () {

        const { status } = this.props;
        const statusLowerCase = status.toLowerCase();

        if (!status.length || statusLowerCase === 'not applicable') return null;

        let style = {
            backgroundColor: 'rgba(47, 128, 237, 0.8)'
        };

        if (statusLowerCase === 'leased'
            || statusLowerCase === 'not available'
            || statusLowerCase === 'off market'
            || statusLowerCase === 'pending'
            || statusLowerCase === 'rented'
            || statusLowerCase === 'sold') {
                style = {
                    backgroundColor: 'rgba(235, 87, 87, 0.7)'
                }
            }

        return (
            <div className="listing-status" style={style}>
                {status}
            </div>
        )
    }
}

export default StatusComponent;